(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zorura-recommendations"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('zorura-recommendations')) {
  customElements.define('zorura-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.loaded) return;
      this.loaded = true;
      const load = async () => {
        try {
          const response = await fetch(this.dataset.url);
          if (!response.ok || !this.isConnected) return;
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = page.querySelector('zorura-recommendations [data-zr-products][data-zr-kind="shopify"]');
          const current = this.querySelector('[data-zr-products]');
          if (!incoming?.children.length || !current || !this.isConnected) return;
          current.replaceChildren(...incoming.children);
          current.dataset.zrKind = 'shopify';
          this.hidden = false;
        } catch (_) {}
      };
      if (!('IntersectionObserver' in window)) { load(); return; }
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        load();
      }, { rootMargin: '300px' });
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
